module.exports = __webpack_public_path__ + "img/4.84a43b50.jpg";